<template>
  <section class="app-main">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" :keywords="keywords"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" :keywords="keywords"></router-view>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  props: ['keywords'],
  computed: {
    key () {
      return this.$route.fullPath
    }
  },
  watch: {}
}
</script>

<style lang="scss" scoped>
  .app-main{
    flex: 1 0 auto;
  }
</style>
